@if (!translationsLoaded()) {
<lib-loader />
} @if (translationsLoaded()) {
<ion-app style="justify-content: normal">
  <meta charset="utf-8" />
  <ion-split-pane contentId="main-content">
    <ion-menu
      menuId="main-menu"
      contentId="main-content"
      type="overlay"
      [hidden]="!showSidebar()"
      (ionWillOpen)="menuOpened()"
      (ionWillClose)="menuClosed()"
    >
      <!-- ion-content allows to scroll the sidebar -->
      @if (hasSession()) {
      <ion-content>
        <lib-sidebar [platform]="'my-ucrop'" />
      </ion-content>
      }
    </ion-menu>
    <ion-router-outlet id="main-content">
      @if (showQueryIsLoading()) {
      <aside id="routing-is-loading">
        <ion-progress-bar type="indeterminate" />
      </aside>
      } @if (hasSession()) {
      <app-main-header />
      } @if (hasSession()) {
      <aside id="bottom-tabs">
        <div class="bottom-tabs-container">
          <lib-bottom-tabs [isMenuOpen]="isMenuOpen()" [platform]="'my-ucrop'" />
        </div>
      </aside>
      }
    </ion-router-outlet>
  </ion-split-pane>
  @if (environment.showBillingPopup && hasSession()) {
  <lib-billing-popup [platform]="'my-ucrop'" />
  }
  <app-popup-cookies />
</ion-app>
}
